import {fireEvent} from 'react-app-events'
import getTrackPath from '@helpers/misc/getTrackPath'

import getRedirectUrl from './getRedirectUrl'
import redirect from './redirect'

export default async function makePayment(order, router) {
  const {url, post} = getRedirectUrl({
    paymentType: order.paymentType,
    transaction: order.transaction,
    intent: order.intent
  })
  if (post === true) {
    redirect(url)
  } else if (url) {
    fireEvent('setPaymentRedirectUrl', url)
    window.location.replace(url)
  } else {
    router.replace(getTrackPath(router, order.websiteId, order._id))
  }
}
